module.exports = __webpack_public_path__ + "img/nto_logo_white.9710bf85.png";